"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var response_1 = require("./response");
var parseResponse = function (response) {
    return (response
        .json()
        .then(function (data) { return data; }, function () { return undefined; })
        .then(function (jsonData) {
        return new response_1.default(response, jsonData);
    }));
};
exports.default = parseResponse;
//# sourceMappingURL=parse-response.js.map